import { Typography, Card } from 'antd'
import { useNavigate } from 'react-router-dom'
import { PlaylistBrief, PlaylistFolder } from '../utils/redux/playlistSlice'
import { apiBaseURL } from '../utils/api'
import './PlaylistSection.scss'

const { Title } = Typography

interface PlaylistSectionProps {
  title: string
  items: PlaylistBrief[] | PlaylistFolder[]
  type: 'playlist' | 'mood' | 'style' | 'daytime' | 'business'
}

export default function PlaylistSection({ title, items, type }: PlaylistSectionProps) {
  const navigate = useNavigate()

  const handleItemClick = (item: PlaylistBrief | PlaylistFolder) => {
    console.log('item:', item)
    if (type === 'playlist') {
      navigate(`/playlist/${item._id}`)
    } else {
      navigate(`/category/${type}/${item._id}`)
    }
  }

  const getImageUrl = (item: PlaylistBrief | PlaylistFolder) => {
    if (type === 'playlist') {
      return `${apiBaseURL}/uploaded/playlists/${item.image}`
    } else if (type === 'business') {
      return `${apiBaseURL}/uploaded/businesses/${item.image}`
    }
     else {
      return `${apiBaseURL}/uploaded/${type}s/${item.image}`
    }
  }

  return (
    <div className="playlist-section">
      <Title level={3} className="section-title">
        {title}
      </Title>
      <div className="playlist-scroll">
        {items.map((item) => (
          <Card
            key={item._id}
            hoverable
            className="playlist-card"
            cover={
              <div className="playlist-image-container">
                <img alt={item.title} src={getImageUrl(item)} className="playlist-image" />
              </div>
            }
            onClick={() => handleItemClick(item)}
          >
            <Card.Meta title={item.title} />
          </Card>
        ))}
      </div>
    </div>
  )
}
